<template>
  <div class="c-question-block__badge">
    <img
        :srcset="`${badge} 1x, ${badgeSizeDouble} 2x`"
        :src="`${badge}`"
        :alt="`${numberOfStarMedal}`"
    >
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";
  import { BADGE_IMAGE_MAP, BADGE_IMAGE_2X_MAP }  from '@/consts/images'

  const starMedal = ref(0)
  const props = withDefaults(
    defineProps<{
      numberOfStarMedal?: number;
    }>(),
    {
      numberOfStarMedal: 0,
    }
  );

  const badge = computed(() => {
    if(0 < props.numberOfStarMedal && props.numberOfStarMedal < 4) {
      return BADGE_IMAGE_MAP[props.numberOfStarMedal]
    }
    else{
      return BADGE_IMAGE_MAP[starMedal.value]
    }
  })
  const badgeSizeDouble = computed(() => {
    if(0 < props.numberOfStarMedal && props.numberOfStarMedal < 4) {
      return BADGE_IMAGE_2X_MAP[props.numberOfStarMedal]
    }
    else{
      return BADGE_IMAGE_2X_MAP[starMedal.value]
    }
  })
</script>
